import { Box, Stack, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';

import { SubPageBreadcrumbHeader } from '@verantos-dev/shared-components';

import { useDatasetBreadcrumbs } from '../hooks/useDatasetBreadcrumbs';

/**
 * Placeholder for `/projects/:projectId/dataset/:datasetId`. The platform
 * does not yet ship a project-scoped analytical-dataset entity (see Phase 3
 * notes) — once it does, this becomes a real detail page.
 *
 * Renders its own breadcrumb + title (OR-6123 F8) — the project header no
 * longer carries the breadcrumb.
 *
 * TODO: cleanup with research_assistant_gen_3 ff
 */
export const ProjectDatasetPlaceholderPage = () => {
  const { datasetId = '' } = useParams<{ datasetId: string }>();
  const { breadcrumbs, datasetName, isLoading } = useDatasetBreadcrumbs();

  return (
    <Box data-testid="project-dataset-placeholder">
      <SubPageBreadcrumbHeader
        id="project-dataset-detail-header"
        breadcrumbs={breadcrumbs}
        title={datasetName ?? 'Analytical dataset'}
        isTitleLoading={isLoading && !datasetName}
      />
      <Box sx={{ paddingX: 6, paddingBottom: 3 }}>
        <Stack gap={1}>
          <Typography variant="body2" color="text.secondary">
            Analytical dataset id: {datasetId || '(none)'}
          </Typography>
          <Typography variant="body2" color="text.disabled">
            Coming soon — no platform endpoint for analytical-dataset detail yet.
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
};
